<template>
  <a-modal
    width="800px"
    title="确认计算结果"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>
      根据已填写信息，
      <span v-if="calculationAbnormal.length" style="color: red;">部分结果异常或有误，建议返回检查</span>
      <span v-else>计算结果如下</span>:
    </div>
    <br>
    <h3>生长性能</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <a-col :span="6" >
          <span>死淘率（%）</span>
          <a-icon v-if="isAbnormal('dieRate')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('dieRate') ? 'abnormalBox' : 'box'">
            {{calculationResult.dieRate?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>产蛋率（%）</span>
          <a-icon v-if="isAbnormal('eggRate')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('eggRate') ? 'abnormalBox' : 'box'">
            {{calculationResult.eggRate?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>不合格蛋率（%）</span>
          <a-icon v-if="isAbnormal('substandardEggRate')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('substandardEggRate') ? 'abnormalBox' : 'box'">
            {{calculationResult.substandardEggRate?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>料蛋比</span>
          <a-icon v-if="isAbnormal('weightCostRatio')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('weightCostRatio') ? 'abnormalBox' : 'box'">
            {{calculationResult.weightCostRatio?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>日均只采食量（g/只）</span>
          <a-icon v-if="isAbnormal('avgDayFeed')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgDayFeed') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgDayFeed?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>日均只产蛋量（g/只）</span>
          <a-icon v-if="isAbnormal('avgDayEgg')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgDayEgg') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgDayEgg?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>平均蛋重（g/枚）</span>
          <a-icon v-if="isAbnormal('avgEggWeight')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgEggWeight') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgEggWeight?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>斤蛋成本（元/斤）</span>
          <a-icon v-if="isAbnormal('avgEggCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgEggCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgEggCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
export default {
  props:['visible','calculationResult','calculationAbnormal'],
  data(){
    return{}
  },
  methods:{
    handleOk() {
      this.$emit('isShow', false)
      this.$emit('calculationConfirm')
    },
    handleCancel() {
      this.$emit('calculationAbnormalInit')
      this.$emit('isShow', false)
    },
    isAbnormal(value){
      return this.calculationAbnormal.includes(value)
    }
  }
}
</script>

<style lang='scss'>
.result{
  background-color:whitesmoke;
  padding: 3px;
  span{
    margin-left: 10px;
  }
  .box{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
  }
  .abnormalBox{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
    color: red;
  }
  .anticon{
    color: orange 
  }
}
</style>